import React from "react";

import { useNavigate } from "react-router";

import { Button, Stack, Typography } from "@mui/material";

import NotificationBanner from "@app/analytics/components/NotificationBanner";
import ROUTES from "@app/common/routes";
import useWorkspace from "@app/common/workspaces/useWorkspace";

const MeetingPolicyBanner = () => {
  const navigate = useNavigate();
  const { workspaceId } = useWorkspace();

  return (
    <NotificationBanner
      button={
        <Button
          variant="contained"
          sx={{ minWidth: "100px", height: "44px" }}
          onClick={() =>
            workspaceId &&
            navigate(ROUTES.workspaceSettingsSettingsById(workspaceId))
          }
        >
          Adjust Settings
        </Button>
      }
    >
      <Stack>
        <Typography variant="bodyPrimaryMed">
          You don't have any policies available yet 😕
        </Typography>
        <Typography
          variant="bodySecondaryReg"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            mt: 0.5,
            flexWrap: "wrap",
          }}
        >
          Read doesn't have enough data to present Workspace policies. Try
          adjusting your Workspace settings so that Read joins all meetings.
        </Typography>
      </Stack>
    </NotificationBanner>
  );
};

export default MeetingPolicyBanner;
